<template>
    <div class="full">
      <CoverFilterSummary v-model="filters"></CoverFilterSummary>
      <v-data-table  :headers="lateHeaders" :pagination.sync="pagination"
         :rows-per-page-items="pagination.rowsPerPageItems"
         :loading="loading"
         :total-items="pagination.totalItems"
         :items="covers" class="elevation-1" >
         <template slot="headers" slot-scope="props">
              <tr>
               <template v-for="header in props.headers">
                  <th  v-if="extendedMode || columnsAlwaysShown.includes(header.value)" :key="$t(header.text)" :class="$t(header.text).toUpperCase() === 'Action'.toUpperCase()?'text-xs-center' :'text-xs-left'">
                     {{ $t(header.text) }}
                   </th>
               </template>
              </tr>
        </template>
        <template v-slot:items="props">
          <tr @click="showCoverDetail(props.item.id)" v-bind:class="selectedRow === props.item.id ?'selectedrow' : ''">
            <td class="text-xs-left" style="width: 10px">
              <v-tooltip v-if="props.item.islate" top>
                <template v-slot:activator="{ on }">
                  <span class="icon-attention" v-on="on"></span>
                </template>
                <span>{{$t('Cover.ListCover.CLAIMABLE_UNTIL_FIELD_NAME')}} {{ $formatDate(props.item.claimLimitAt)}}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-left"><span class="twoline">{{ props.item.seller.name }}<span class="smalltext greytext"> {{ props.item.seller.identifierType }} {{ props.item.seller.identifierValue }} </span></span></td>
            <td class="text-xs-left"><span class="twoline">{{ props.item.buyer.name }}<span class="smalltext greytext">{{ props.item.buyer.identifierType }} {{ props.item.buyer.identifierValue }}</span></span> </td>
            <td class="text-xs-left"><span class="twoline latedetails">{{ $formatDate(props.item.dueAt) }}<span class="smalltext redtext">{{$t('Cover.ListCover.DAYS_LATE_DESC', { daysLateNumber: props.item.daysLate })}}</span></span> </td>
            <td v-if="extendedMode" class="text-xs-left">{{ props.item.amount}}</td>
            <td v-if="extendedMode" class="text-xs-left">{{ props.item.number }}</td>
            <td v-if="extendedMode" class="text-xs-left">{{ props.item.coverPrice}}</td>
            <td v-if="extendedMode" class="text-xs-center">
              <span>
                <v-btn @click.stop v-if="canSettleCover" color="primary" small @click="settleCover(props.item.id)">{{$t('Cover.ListCover.SETTLE_COVER_BTN')}}</v-btn>
                <v-btn @click.stop v-if="canClaimCover && props.item.canbeclaimed" color="primary" small @click="showCreateClaim(props.item.id)">{{$t('Cover.ListCover.CLAIM_BTN')}}</v-btn>
              </span>
            </td>
          </tr>
        </template>
        <template slot="no-data">
              <div v-if="loading" class="text-xs-center">
                    <v-progress-circular indeterminate  color="primary"></v-progress-circular>
              </div>
              <div v-else>
                  <p class="centerText"> {{$t('Cover.ListCover.NO_DATA_AVAILABLE_DESC')}} </p>
              </div>
        </template>
      </v-data-table>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import auth from '@/services/Auth'
import transactorApi from '@/services/TransactorApi'
import CoverFilterSummary from '@/components/common/CoverFilterSummary.vue'

export default {
  components: { CoverFilterSummary },
  data () {
    return {
      selectedRow: '',
      columnsAlwaysShown: ['islate', 'seller', 'buyer', 'duedate'],
      settleCoverSuccessText: this.$t('Cover.ListCover.COVER_SETTLED_DESC'),
      settleCoverFailedText: this.$t('Cover.ListCover.CANNOT_SETTLE_COVER_DESC')
    }
  },
  watch: {
    pagination: {
      async handler () {
        this.$store.dispatch('coverlate/startLoadCovers')
        await this.searchCovers(this.filters.identifierValue, this.filters.identifierTypeCode, this.filters.identifierCountryCode, this.filters.coverId)
      }
    },
    filters: {
      async handler () {
        this.$store.dispatch('coverlate/startLoadCovers')
        await this.searchCovers(this.filters.identifierValue, this.filters.identifierTypeCode, this.filters.identifierCountryCode, this.filters.coverId)
      }
    },
    deep: true
  },
  methods: {
    async showCoverDetail (coverId) {
      this.selectedRow = coverId
      this.InitializeDetailCover()
      await this.$parent.showCoverInfoDetail(coverId, true, 'Late', false)
    },
    async showCreateClaim (coverId) {
      this.InitializeDetailCover()
      await this.$parent.showCoverInfoDetail(coverId, true, 'Late', true)
    },
    InitializeDetailCover () {
      this.$parent.setHeightForSideInfo()
      this.$store.dispatch('cover/setExtendedMode', false)
    },
    async settleCover (coverId) {
      let success = await this.$parent.settleCover(coverId)
      if (success) {
        await this.searchCovers(this.filters.identifierValue, this.filters.identifierTypeCode, this.filters.identifierCountryCode, this.filters.coverId)
      }
    },
    async searchCovers (identifierValue, identifierTypeCode, identifierCountryCode, coverId) {
      if (identifierValue.length > 0) {
        var transactorId = await transactorApi.fetchCompanyByExternalId(identifierCountryCode, identifierTypeCode, identifierValue)
        if (transactorId.length > 0) {
          this.$store.dispatch('coverlate/getCoversLate', { companyId: transactorId, coverId: coverId })
        } else {
          this.$store.dispatch('coverlate/getEmptyCovers')
        }
      } else {
        this.$store.dispatch('coverlate/getCoversLate', { companyId: undefined, coverId: coverId })
      }
    }
  },
  computed: {
    pagination: {
      get: function () {
        return this.paginationData
      },
      set: function (value) {
        this.$store.dispatch('coverlate/setPagination', value)
      }
    },
    items () {
      return this.covers
    },
    canClaimCover: function () {
      let hasLegacyClaimAccess = auth.hasClaimAccess()
      let hasBuyerClaimAccess = auth.hasBuyerClaimAccess()
      return hasLegacyClaimAccess && !hasBuyerClaimAccess
    },
    canSettleCover: function () {
      return this.$parent.hasCoverageAccess()
    },
    ...mapState('cover', ['extendedMode', 'lateHeaders']),
    ...mapState('coverlate', ['covers', 'paginationData', 'loading']),
    ...mapState('listcovertabs', ['filters'])
  }
}
</script>
